import { fromJS, Map } from "immutable";
import { createSelector } from "reselect";

const getRawConfig = (state) => state?.config;

const getConfig = createSelector(
  [getRawConfig],
  (config) => config ? fromJS(config) : Map()
);

export const getContractTypeForB2cSTR = createSelector(
  [getConfig],
  (config) => config.getIn(["b2c", "shortTermReservation", "contractType"])
);

export const getContractTypeForB2cLTR = createSelector(
  [getConfig],
  (config) => config.getIn(["b2c", "longTermReservation", "contractType"])
);

export const getMinDaysForB2cLtr = createSelector(
  [getConfig],
  (config) => config.getIn(["b2c", "longTermReservation", "thresholdInDays"])
);

export const getRentObjectStationIdForB2cLtr = createSelector(
  [getConfig],
  (config) =>
    config.getIn(["b2c", "longTermReservation", "fetchRentObjectsFromStationId"])
);

export const getContractTypeForB2bSTR = createSelector(
  [getConfig],
  (config) => config.getIn(["b2b", "shortTermReservation", "contractType"])
);

export const getContractTypeForB2bLTR = createSelector(
  [getConfig],
  (config) => config.getIn(["b2b", "longTermReservation", "contractType"])
);

export const getMinDaysForB2bLtr = createSelector(
  [getConfig],
  (config) => config.getIn(["b2b", "longTermReservation", "thresholdInDays"])
);

export const getRentObjectStationIdForB2bLtr = createSelector(
  [getConfig],
  (config) =>
    config.getIn(["b2b", "longTermReservation", "fetchRentObjectsFromStationId"])
);

export const getTimeSelectionStepSizeInMinutes = createSelector(
  [getConfig],
  (config) => config.getIn(["timeSelectionStepSizeInMinutes"], 15)
);

export const getCreditCardsEnabled = createSelector(
  [getConfig],
  (config) => config.getIn(["creditCardsEnabled"], true)
);

export const getHistoryPageSize = createSelector(
  [getConfig],
  (config) => config.getIn(["historyPageSize"], 10)
);
